module.exports = __webpack_public_path__ + "img/check-circle-border.a51e86bb.svg";